.baseListContainer {
	border: 1px solid #efefef;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	border-radius: 12px;
	width: 100%;
	height: 100%;
}

.baseListHeaderContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	padding: 0.9375rem;
	box-sizing: border-box;
}

.baseListFooterContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	padding: 0.625rem;
	width: 100%;
	align-items: center;
	box-sizing: border-box;
}

.baseListInfoContainer {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.3125rem;
	width: 100%;
}

.baseListTitleIconWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.3125rem;
	align-items: center;
}

.baseListTitleRow {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	width: 100%;
	justify-content: space-between;
}

.baseListTitleBadgeRow {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	width: 100%;
}

.totalSelectedChip:global(.MuiChip-root) {
	border-radius: 6px;
	height: 27px;
	min-height: fit-content;
	padding: 0.1875rem 0.5rem;

	& span {
		color: #6862b1;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 500;
		letter-spacing: 0;
		padding: 0;
	}
}

.selectedChip:global(.MuiChip-root) {
	border-radius: 5px;
	height: 22px;
	min-height: fit-content;
	padding: 0.125rem 0.25rem;

	& span {
		color: #555555;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 500;
		letter-spacing: 0;
		padding: 0;
	}
}

.baseListTitle:global(.MuiTypography-root) {
	color: #333333;
	font-weight: 600;
	font-size: 1rem;
	line-height: 1.4;
	letter-spacing: 0;
}

.baseListDescription:global(.MuiTypography-root) {
	color: #757575;
	font-weight: 400;
	line-height: 1.6;
	font-size: 0.9375rem;
	letter-spacing: 0;
}

.selectAllContainer {
	border-bottom: 1px solid #e5e7eb;
	border-top: 1px solid #e5e7eb;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 0.75rem 2rem;
	box-sizing: border-box;
}

.selectAllWrapper {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	padding-left: 0.125rem;
}

.optionIconWrapper {
	border-radius: 7px;
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.3125rem;
	background-color: #fbf7ff;
	flex-shrink: 0;
	box-sizing: border-box;

	& svg {
		color: #955fcb;
		flex-shrink: 0;
	}
}

@media (max-width: 768px) {
	.baseListTitleIconWrapper {
		flex-direction: column;
	}

	.baseListTitleBadgeRow {
		flex-direction: column;
	}

	.baseListDescription:global(.MuiTypography-root) {
		padding-right: unset;
		text-align: center;
	}

	.baseListTitle:global(.MuiTypography-root) {
		text-align: center;
	}

	.selectAllContainer {
		flex-direction: column-reverse;
		gap: 0.5rem;
		justify-content: center;
		padding: 0.5rem;
	}

	.selectAllWrapper {
		flex-direction: column-reverse;
		gap: 0.5rem;
	}
}
